export const ACTION_UPDATE_LTS_STATION_DETAILS = '@rails/lts/ACTION_UPDATE_LTS_STATION_DETAILS';
export const ACTION_LTS_FETCH_START = '@rails/lts/ACTION_LTS_FETCH_START';
